export default {"src":"/_next/static/media/SITC.6483f253.svg","height":18,"width":18};